import styled from "styled-components"
import { useHistory } from "react-router-dom"
import Brand from "../components/Brand"

const PendingRestoApprovalPage = () => {
  const h = useHistory()

  return (
    <Container>
      <Brand type="resto" />
      <SuccessContainer>
        <Title>Tu restaurante está pendiente de aprobación</Title>
        <Paragraph>Tu cuenta existe, pero aún no puede ingresar al panel.</Paragraph>
        <Paragraph>Antes de iniciar sesión, el equipo debe aprobar tu restaurante.</Paragraph>
        <Paragraph>Te avisaremos cuando la aprobación esté lista.</Paragraph>
        <StyledButton onClick={() => h.push("/login")}>Volver al login</StyledButton>
      </SuccessContainer>
    </Container>
  )
}

export default PendingRestoApprovalPage

const Container = styled.div`
  padding: 20px;
`

const SuccessContainer = styled.div`
  padding: 40px 20px;
  text-align: center;
`

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
`

const Paragraph = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 5px 0;
`

const StyledButton = styled.button`
  width: 100%;
  border-radius: 8px;
  margin-top: 30px;
  color: white;
  height: 50px;
  border: 0;
  background: #ff0102;
  font-weight: bold;
  cursor: pointer;
`
